module.exports = __webpack_public_path__ + "c7628f78374d040326d08bbff614d6ba.png";